module.exports = __webpack_public_path__ + "static/media/GDocsCookieNotice_ID.dd5c2f29.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cust_PDF/GDocsCookieNotice_ID.pdf
// module id = 696
// module chunks = 4